// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

import { SizeRegistry } from '../../../../dsl/composables'

import { quantityPickerConfigI } from './CartItem.contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export enum CartItemSizeMap {
  Medium = 'medium',
  Small = 'small',
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum CartItemAction {
  AddToCart = 'addToCart',
  Delete = 'delete',
  Favourite = 'addToFavourite'
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const sizeClassRegistry: SizeRegistry<string> = {
  [CartItemSizeMap.Medium]: '',
  [CartItemSizeMap.Small]: '--small'
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const quantityPickerConfig: quantityPickerConfigI = {
  MAX_VALUE: 100,
  COUNTER_VALUE: 1,
  MIN_VALUE: 0
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const CART_ITEM_COMPONENT_KEY = 'CartItemComponent'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum CartItemLayout {
  Basic = 'basic',
  Rich = 'rich'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const cartItemComponentRegistry: Record<string, AsyncComponent> = {
  [CartItemLayout.Basic]: () => import(/* webpackChunkName: "cart/CartItemBasic" */ './versions/Basic.vue'),
  [CartItemLayout.Rich]: () => import(/* webpackChunkName: "cart/CartItemRich" */ './versions/Rich.vue')
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface CartItemComponentConfig {
  layout: string
  shouldLinkCategory: boolean
  shouldPreserveDeleted: boolean
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const CART_ITEM_COMPONENT_CONFIG_MAP: CartItemComponentConfig = {
  layout: CartItemLayout.Rich,
  shouldLinkCategory: false,
  shouldPreserveDeleted: true
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const QUANTITY_PICKER_COMPONENT_KEY = 'QuantityPickerComponent'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface QuantityPickerComponentConfig {
  minusIcon: string
  plusIcon: string
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const QUANTITY_PICKER_COMPONENT_CONFIG_MAP: QuantityPickerComponentConfig = {
  minusIcon: 'MinusIcon',
  plusIcon: 'PlusIcon'
}
